import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { diagnosisData } from 'src/app/components/diagnosis/diagnosis.data';

type Step = 'step1' | 'step2' | 'step3' | 'step4' | 'step5' | 'step6';

export interface Diagnosis {
  step1: number;
  step2: number;
  step3: number;
  step4: number;
  step5: number;
  step6: number;
}


@Injectable({
  providedIn: 'root'
})
export class DiagnosisService {
  execute(value: Diagnosis) {
    const sum = [0, 0, 0, 0, 0, 0];
    Object.keys(diagnosisData)
      .forEach(k => {
        const key = k as Step;
        const data = diagnosisData[key][value[key]];
        for (const i in data) {
          const index = Number(i);
          sum[index] += data[index];
        }
      });
    return of<number>(sum.indexOf(Math.max(...sum)));

  } 
}
